import UserLesson from '@/modules/lesson/models/UserLesson'

export default {
  namespaced: true,
  actions: {
    async fetchAll({ _dispatch }, type) {
      try {
        const userLessons = await this._vm.$axios.get(
          `api/${type}/user-lessons`
        )
        await UserLesson.insert({ data: userLessons }, { root: true })
      } catch (error) {
        throw error
      }
    },
    async getLessonsForStudentId({ _dispatch }, { payload }) {
      try {
        const userLessons = await this._vm.$axios.get(
          `api/teachers/custom-classes/${payload.customClassId}/student-lessons?student_id=${payload.studentId}`
        )
        await UserLesson.insertOrUpdate({ data: userLessons }, { root: true })

        return userLessons
      } catch (error) {
        throw error
      }
    },
    async getLessonsForChildId({ _dispatch }, childId) {
      try {
        const userLessons = await this._vm.$axios.get(
          `api/parents/lessons/children?child_id=${childId}`
        )
        await UserLesson.insertOrUpdate({ data: userLessons }, { root: true })

        return userLessons
      } catch (error) {
        throw error
      }
    }
  }
}
